var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircleDown = function SvgArrowCircleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-circle-down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.836 10a10 10 0 1 0 10-10 10.012 10.012 0 0 0-10 10Zm18.823 0a8.823 8.823 0 1 1-8.823-8.824A8.833 8.833 0 0 1 19.66 10Zm-8.454-3.553a.588.588 0 0 1 .83 0l3.138 3.137a.588.588 0 0 1 0 .832l-3.137 3.137a.588.588 0 0 1-.831-.831l2.132-2.134H6.914a.588.588 0 1 1 0-1.176h6.423l-2.132-2.134a.588.588 0 0 1 0-.83Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-circle-down_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.836)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgArrowCircleDown;